import { Base } from './_base.model';

export class SpeakerApprovalGroup extends Base {
  id: number;
  speaker_tiering_form_id: number;
  bureaus: any[];
  tiering_levels: any[];
  tiering_sub_levels: any[];
  specialties: any[];
  client_levels: any[];
  rank: number;
  is_default: boolean;
}
